import { Alert } from "@mui/material";
import collect from "collect.js";
import { useLazyGetMovementQuery } from "modules/pvs_activities/redux/service/movements";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getFormattedDate } from "helpers";
import Spinner from "components/spinner/Spinner";
const MissionMovementHistoryModal = ({ missionID, countryName, onClose }) => {

  const { t } = useTranslation();
  const [movementsTrigger, movementRes] = useLazyGetMovementQuery();

  const [isShow1, setIsShow1] = useState(true);
  const closeModal = () => {
    setIsShow1(false);
    onClose();
  };

  useEffect(() => {
    if (isShow1) {
      movementsTrigger({ missionID: missionID });
    }
  }, [isShow1]);

  return (
      <Modal show={isShow1} size="md" centered={true}>
        <Modal.Header className="p-4">
          <Modal.Title>{t("-1", `${countryName} History`)}</Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="form-control form-control-sm row m-0">
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {
                movementRes?.isLoading ? <Spinner message="Loading data..." />
                  :
                  movementRes.data?.length > 0
                    ? (
                      <table className="table table-striped" style={{ padding: "10px" }}>
                        <thead>
                          <tr>
                            <th className="fw-bold ps-3">{t("-1", "Process Name")}</th>
                            <th className="fw-bold ">{t("-1", "Status")}</th>
                            <th className="fw-bold ">{t("-1", "Last Update")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {collect(movementRes.data).sortBy(item => item?.relationProcess?.rank).all().map((item, index) => (
                            <tr key={index}>
                              <td className="ps-3">{item.relationProcess ? item.relationProcess?.name : "Other"}</td>
                              <td>
                                {item.status === 1
                                  ? t("-1", "Assigned")
                                  : item.status === 2
                                    ? t("-1", "Completed")
                                    : t("-1", "Un Assigned")}
                              </td>
                              <td> {getFormattedDate(item.updated_date)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div className="col-md-12 px-4">
                        <Alert severity="info" sx={{ justifyContent: "center", fontSize: "12px" }}>
                          Mission Manager is not assigned.
                        </Alert>
                      </div>
                    )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="p-4"></Modal.Footer>
      </Modal>
  );
};

export default MissionMovementHistoryModal;
